import { useEffect, useState } from 'react'

/** The mockup's narrow layout for the uptime bars (30 days instead of 90): `(max-width: 760px)`. */
export const NARROW_QUERY = '(max-width: 760px)'

const media = (): MediaQueryList | undefined =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(NARROW_QUERY) : undefined

export function useNarrow(): boolean {
  const [narrow, setNarrow] = useState(() => media()?.matches ?? false)
  useEffect(() => {
    const m = media()
    if (!m) return
    const on = () => {
      setNarrow(m.matches)
    }
    m.addEventListener('change', on)
    return () => {
      m.removeEventListener('change', on)
    }
  }, [])
  return narrow
}
